module.exports = __webpack_public_path__ + "img/2.260ee5b3.png";